module.exports = __webpack_public_path__ + "img/img_left_nav_bonus_hover.8e4702b9.svg";